/** What the signed-in user may do in the add-in, as GET api/v1/OutlookPlugin/Session answers it. */
export default class Permissions {
    public ContactRead = true;
    public PersonCreate = true;
    public InstitutionCreate = true;
    public ContactNoteRead = true;
    public ContactNoteWrite = true;
    public TodoRead = true;
    public TodoCreate = true;
    public LeadRead = true;
    public LeadCreate = true;
    public AttachmentWrite = true;

    /** Whether an answer states every right, so nothing is read as denied for being merely absent. */
    public static isComplete(dto: any): boolean {
        return Object.keys(new Permissions()).every(right => typeof dto?.[right] === "boolean");
    }

    public static fromDto(dto: any): Permissions {
        const permissions = new Permissions();
        Object.keys(permissions).forEach(right => (permissions[right] = dto?.[right] === true));
        return permissions;
    }

    /** The scanned business card can become either, so the way in is offered while one of them may be created. */
    public get ContactCreate(): boolean {
        return this.PersonCreate || this.InstitutionCreate;
    }
}
